import React, { useEffect, useState } from "react";
import {
    EditorState,
    convertFromRaw,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { mdToDraftjs } from "draftjs-md-converter";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const EditorUC = (props) => {
    const [editorState, setEditorState] = useState(undefined);

    useEffect(() => {
        const { value } = props;
        if (value) {
            const rawData = mdToDraftjs(value);
            const contentState = convertFromRaw(rawData);
            const newEditorState = EditorState.createWithContent(contentState);
            const content = newEditorState.getCurrentContent();

            const editorStateNews = EditorState.createWithContent(content);
            setEditorState(editorStateNews);
        }
    }, []);

    return (
        <Editor
            readOnly
            toolbarHidden
            editorState={editorState}
            toolbarClassName="demo-toolbar-absolute"
            wrapperClassName="demo-wrapper"
            editorClassName="demo-editor"
        />
    );
}

export default EditorUC;
